
const userInitials = (f, l) => {
    return `${f.charAt(0)}${l.charAt(0)}`
}

export default userInitials;
